import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';
import Button from 'packages/ui/Button';
import { Link } from 'react-router-dom';
import { DepositsUIProvider } from './DepositsContextProvider';

const DepositsList = React.lazy(() => import('./Deposits'));

function Deposits(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>لیست واریزی‌ها</PageTitle>
        <Button as={Link} type="anchor" to="/deposits/new">
          افزودن واریزی جدید
        </Button>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <DepositsUIProvider>
          <DepositsList {...props} />
        </DepositsUIProvider>
      </Suspense>
    </Page>
  );
}

export default Deposits;
